var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LayoutGridOverview"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},_vm._l((_vm.$themeSettings.global.gridColumns),function(index){return _c('div',{key:`grid-${index}`,staticClass:"col"},[_c('span',{staticClass:"d-none"},[_vm._v(_vm._s(index))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }